import Link from 'next/link';
import styled from 'styled-components';
import { theme } from 'styled-tools';

// TODO: separate all of these into their own styled components
const TagsUl = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    list-style: none;
    padding: 0;
    margin: 0;
    display: inline-block;
    text-align: center;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;

    a {
      display: inline-block;
      color: ${theme('colors.orange')};
      background-color: ${theme('colors.lightGray')};
      text-align: center;
      padding: 8px;
      min-width: 2rem;

      &:hover {
        background-color: ${theme('colors.mediumGray')};
      }
      &:active,
      &.active {
        color: ${theme('colors.white')};
        background-color: ${theme('colors.orange')};
      }
    }
  }
`;

const TagList = ({ tags }) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <TagsUl>
      {tags
        .sort((a, b) => (a.label?.toLowerCase() < b.label?.toLowerCase() ? -1 : 1))
        .map((tag) => (
          <li key={tag.slug}>
            <Link href={`/tags/${tag.slug}`}>{`${tag.label} (${tag.count})`}</Link>
          </li>
        ))}
    </TagsUl>
  );
};

export default TagList;
